<template>
    <Teleport to="body">
      <div v-show="modalActive" class="modal-bg">
        <div class="modal" :class="size">
          <div class="modal-header">
            <h3 style="text-align: center; color: white; margin-top: 20px;">Chúc mừng bạn đã đăng ký thành công!</h3>
            <h3 style="text-align: center; color: white; margin-bottom: 20px; padding: 0px 12px;">
              Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất</h3>
          </div>

          <div class="modal-content">
            <button class="delete" @click="returnHome">
              <p class="btn-text">Quay về trang chủ</p>
            </button>
          </div>
          <p style="color: white; font-size: 15px; text-align: center; margin-bottom: 25px;">Trở về trang chủ sau: {{ countdown }}</p>
        </div>
      </div>
    </Teleport>
  </template>
<script>

export default {
  props: {
    modalActive: {
      type: Boolean,
      require: false
    },
    size: {
      type: String,
      require: false,
      default: 'default'
    },
    countdown: {
      type: Number,
      require: false
    }
  },
  data () {
    return {
      name: null,
      phoneNum: null,
      email: null,
      propertiesToCheck: ['name', 'phoneNum', 'email'],
      isValid: false,
      msg: null,
      cacheBuster: Date.now()
    }
  },
  methods: {
    returnHome () {
      this.$router.push('/')
    }
  },
  emits: ['close']
}
</script>
  <style scoped>
  .modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1000;
  }

  .modal {
    background: #fff;
    width: 700px;
    align-self: center;
    border-radius: 12px;
    width: 450px;
    background-color: #006884;
  }

  .modal-header {
    position: relative;
    padding: 16px 48px;
  }

  .modal-header h2 {
    margin-bottom: 10px;
  }

  .modal-header p {
    color: #ababab;
    font-size: 15px;
  }

  .modal-content {
    padding: 0 16px;
    padding-top: 0px;
    display: flex;
    justify-content: center
  }

  .modal-content button {
    position: relative;
    padding: 15px 25px;
    border-radius: 15px;
    outline: none;
    border: none;
    font-weight: bold;
    cursor: pointer;
    overflow: hidden;
  }

  .modal-content .delete {
    color: #fff;
    background: #F9BA10;
  }

  .modal-content .cancel {
    color: #969393;
    background: #efebeb;
  }

  .modal-content i {
    margin-right: 5px;
  }

  .btn-container button {
      position: relative;
      padding: 12px 30px;
      color: #fff;
      background-color: #0298cf;
    }

    .btn-text {
      font-size: 15px;
    }

    .loading .btn-text {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease;
    }

    .loading::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      pointer-events: none;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 3px solid transparent;
      border-top-color: white;
      border-right-color: white;
      animation: loading 1s ease infinite;
    }

    @keyframes loading {
      0% {
        transform: rotate(0turn);
      }
      100% {
        transform: rotate(1turn);
      }
    }

    input, select, textarea {
      width: 100%;
      padding: 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      resize: vertical;
    }

    label {
      padding: 12px 12px 12px 0;
      display: inline-block;
    }

    .col-30 {
      float: left;
      width: 30%;
      margin-top: 6px;
    }

    .col-70 {
      float: left;
      width: 100%;
      margin-top: 12px;
    }

    .col-70 input {
      border-radius: 15px;
    }

    .row {
      margin: 10px 0px;
    }

    /* Clear floats after the columns */
    .row::after {
      content: "";
      display: table;
      clear: both;
    }

    .close-icon {
      color: white;
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      transition: color 0.2s ease-in-out;
    }

    .close-icon:hover {
      color: red;
    }
  </style>
